import { Box } from '@chakra-ui/react';
import React from 'react';

import { TapeBuilderUI } from '@finley-technologies/tape-builder';

import {
  GeneratedTapePanel,
  OperationPanel,
  RawTapePanel,
  ConfigTapePanel,
  ReceivableResponseTapeOperationPanel,
} from './commonPanel';
import type { TapePanelProps } from './commonTapeNode';
import { DbTapePanel } from './DbPanel';
import { getGraphNodeById, TapeBuilderMode, useGraph } from './GraphContext';

type SwitchPanelProps = Omit<TapePanelProps, 'schema' | 'tapeBuilderNode'> & {
  nodeId: string;
  mode: TapeBuilderMode;
};
export const SwitchTapePanel = ({
  nodeId,
  onConfigChange,
  onDelete,
  mode,
  orgSlugMap,
}: SwitchPanelProps) => {
  const graphContext = useGraph();
  const tapeBuilderNode = getGraphNodeById(graphContext, nodeId);

  if (!tapeBuilderNode) {
    return <Box>Node {nodeId} was not found</Box>;
  }
  const { tapeBuilderNodeType: nodeType } = tapeBuilderNode.metadata;
  const uiNode = TapeBuilderUI.getUINodeByType(nodeType);
  const schema = uiNode.getJsonSchema();
  const commonProps = {
    tapeBuilderNode,
    onConfigChange,
    onDelete,
    schema,
    mode,
    orgSlugMap,
  };

  // Wrap content in a Box that fills height
  const content = (() => {
    switch (uiNode.nodeType) {
      case 'db_node':
        return <DbTapePanel {...commonProps} />;
      case 'operation_calcAgent':
        return <ReceivableResponseTapeOperationPanel {...commonProps} />;
      default:
        if (uiNode.isOperation) {
          return <OperationPanel {...commonProps} />;
        }
        if (uiNode.artifactType === 'configTape') {
          return <ConfigTapePanel {...commonProps} />;
        }
        if (uiNode.isRaw) {
          return <RawTapePanel {...commonProps} />;
        }
        return <GeneratedTapePanel {...commonProps} />;
    }
  })();

  return (
    <Box height="100%" display="flex" flexDirection="column">
      {content}
    </Box>
  );
};
